import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { lawyerService } from '../../../services/LawyerService';
import ReactPaginate from 'react-paginate';

class AdminLawyer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newLawyerDocument: {
        title: '',
        document: '',
        date: ''
      },
      existingLawyerDocuments: [],
      deleteLawyerDocument: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    lawyerService
      .getAll()
      .then(jsonResponse => {
        this.setLawerState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    lawyerService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setLawerState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setLawerState = response => {
    let existingLawyerDocuments = { ...this.state.existingLawyerDocuments };
    let pagination = { ...this.state.pagination };
    existingLawyerDocuments = response.lawyer_documents;
    pagination = response.pagination;

    this.setState({ existingLawyerDocuments });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newLawyerDocument = this.state.newLawyerDocument;
    newLawyerDocument[field] = event.target.value;

    this.setState({
      newLawyerDocument
    });
  };

  onDropDocument = documents => {
    let newLawyerDocument = { ...this.state.newLawyerDocument };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newLawyerDocument.document = documents[0];

      self.setState({ newLawyerDocument });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newLawyerDocument = { ...this.state.newLawyerDocument };
    newLawyerDocument.document = null;

    this.setState({ newLawyerDocument });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newLawyerDocument = { ...this.state.newLawyerDocument };
    newLawyerDocument = {
      title: '',
      document: ''
    };

    this.setState({ newLawyerDocument });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newLawyerDocument.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/lawyer_documents/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/lawyer_documents/${this.state.newLawyerDocument.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingLawyerDocuments = this.state.existingLawyerDocuments.slice();

        let index = existingLawyerDocuments.findIndex(
          existingLawyerDocument =>
            existingLawyerDocument.id === jsonResponse.id
        );

        if (index !== -1) {
          existingLawyerDocuments[index] = jsonResponse;
        } else {
          existingLawyerDocuments.push(jsonResponse);
        }

        this.setState({ existingLawyerDocuments });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Documentul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Documentul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'lawyer_document[title]',
      this.state.newLawyerDocument.title
    );
    formData.append(
      'lawyer_document[add_dat]',
      this.state.newLawyerDocument.date
    );

    if (this.state.newLawyerDocument.document) {
      let document = this.state.newLawyerDocument.document;
      appendAttachment(formData, `lawyer_document[document]`, document);
    }

    return formData;
  }

  setLawyerDocumentForEdit = newLawyerDoc => {
    let newLawyerDocument = { ...this.state.newLawyerDocument };
    newLawyerDocument = Object.assign({}, newLawyerDoc);
    this.setState({ newLawyerDocument });

    if (newLawyerDocument.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteLawyerDocument = { ...this.state.deleteLawyerDocument };
    deleteLawyerDocument = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteLawyerDocument });
  };

  closeDeleteDialog = () => {
    let deleteLawyerDocument = { ...this.state.deleteLawyerDocument };
    deleteLawyerDocument = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteLawyerDocument });
  };

  handleDelete = () => {
    lawyerService
      .deleteLawyerDocument(this.state.deleteLawyerDocument.deleteId)
      .then(() => {
        let existingLawyerDocuments = this.state.existingLawyerDocuments.slice();
        existingLawyerDocuments = existingLawyerDocuments.filter(
          lawyerDocument =>
            lawyerDocument.id !== this.state.deleteLawyerDocument.deleteId
        );
        this.setState({ existingLawyerDocuments });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Documentul a fost stears cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title">Juridic</h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga un document nou</h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu *
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newLawyerDocument.title}
                  />
                </div>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">Data *</h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newLawyerDocument.date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newLawyerDocument.document}
                    documentFilename={
                      this.state.newLawyerDocument.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newLawyerDocument.id
                        ? 'Editează Proiect'
                        : 'Adaugă Proiect'}
                    </button>
                  </div>
                  {Object.values(this.state.newLawyerDocument) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingLawyerDocuments.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Documente existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingLawyerDocuments.map(lawyerDocument => (
                      <div
                        className="existing-items__content-card"
                        key={lawyerDocument.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {lawyerDocument.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.setLawyerDocumentForEdit(lawyerDocument)
                            }
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.openDeleteDialog(lawyerDocument.id)
                            }
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteLawyerDocument.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest document?"
                    aditionalText="Dupa stergere, documentul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminLawyer;
